/**
 * Web mock for @stripe/stripe-react-native
 * On web, we use @stripe/stripe-js instead
 */

// Mock NativeStripeSdkModule - this is what gets imported
// It's created by TurboModuleRegistry.getEnforcing('StripeSdk')
const NativeStripeSdkModule = {
  initialize: () => {},
  // Add any other methods that might be called
};

// Mock useStripe hook
const useStripe = () => {
  return {
    createPaymentMethod: async () => ({ error: null, paymentMethod: null }),
    confirmPayment: async () => ({ error: null, paymentIntent: null }),
    retrievePaymentIntent: async () => ({ error: null, paymentIntent: null }),
    confirmSetupIntent: async () => ({ error: null, setupIntent: null }),
    retrieveSetupIntent: async () => ({ error: null, setupIntent: null }),
    handleURLCallback: async () => ({ error: null }),
    isApplePaySupported: false,
    isGooglePaySupported: false,
    presentApplePay: async () => ({ error: null }),
    confirmApplePayPayment: async () => ({ error: null }),
    updateApplePaySummaryItems: async () => ({ error: null }),
    openApplePaySetup: async () => ({ error: null }),
    presentGooglePay: async () => ({ error: null }),
    createGooglePayPaymentMethod: async () => ({ error: null }),
  };
};

// Mock CardField component
const CardField = () => null;

// Mock other exports
const ApplePayButton = () => null;
const GooglePayButton = () => null;
const useApplePay = () => ({ isApplePaySupported: false });
const useGooglePay = () => ({ isGooglePaySupported: false });

// Export NativeStripeSdkModule as default (this is what's imported by specs/NativeStripeSdkModule.js)
module.exports = NativeStripeSdkModule;
module.exports.default = NativeStripeSdkModule;
module.exports.NativeStripeSdkModule = NativeStripeSdkModule;

// Also export the hooks and components for when the package is imported directly
module.exports.useStripe = useStripe;
module.exports.CardField = CardField;
module.exports.ApplePayButton = ApplePayButton;
module.exports.GooglePayButton = GooglePayButton;
module.exports.useApplePay = useApplePay;
module.exports.useGooglePay = useGooglePay;
